import React from "react";
import {
  IonLabel,
  IonRadioGroup,
  IonItem,
  IonRadio,
  IonRow
} from "@ionic/react";
import { isMobile } from "../../../../utils/common";
import "./InvoiceRadioContainer.scss";
function InvoiceRadioContainer(props: any) {
  return (
    <IonRow className={`radio-card ${isMobile ? "mob" : "web"}`}>
      {props.radioButtonData?.map((radioOption: any, index: number) => (
          <IonRadioGroup
            class={`radio-button-align ${isMobile ? "mob" : "web"}`}
            onIonChange={e => props.handleChange(e)}
            name={radioOption.OPTION_VALUE}
            value={props?.invoiceRadio}
            key={index}
          >
            <IonItem class="label-text" lines="none" key={radioOption.OPTION_TITLE}>
              <IonRadio
                value={radioOption.value}
                class="radiobutton radio-group"
                mode="md"
              />
              <IonLabel>{radioOption.Display_title}</IonLabel>
            </IonItem>
          </IonRadioGroup>
        ))}
    </IonRow>
  );
}

export default InvoiceRadioContainer;
